export const apiCreate = (): string => '/commercial/clients/'
export const apiList = (id?: string): string =>
  !id ? '/commercial/clients/' : `/commercial/clients/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/clients/update/${id}`
export const apiDelete = (id: string): string => `/commercial/clients/${id}`
